'use client';

import { createContext, useContext, useState } from 'react';

// Types
import { MappedClinic } from '@/types/clinics/clinics';
import { Context, ProviderProps } from '@/types/contexts/clinicFinderContext';

export const ClinicFinderContext = createContext<Context>({
  clinics: [],

  filteredClinics: [],
  setFilteredClinics: () => [],
});

export const ClinicFinderProvider = ({ clinics, children }: ProviderProps) => {
  const [filteredClinics, setFilteredClinics] =
    useState<MappedClinic[]>(clinics);

  return (
    <ClinicFinderContext.Provider
      value={{
        clinics: clinics,

        filteredClinics: filteredClinics,
        setFilteredClinics: setFilteredClinics,
      }}
    >
      {children}
    </ClinicFinderContext.Provider>
  );
};

export const useClinicFinderContext = () =>
  useContext<Context>(ClinicFinderContext);
